import { useEffect } from 'react';
import { FormikContextType } from 'formik';
import { Row, Col } from 'antd';
import FormContent from 'components/new-ui/composed/multistep-form/FormContent';
import { MultiStepFormProvider } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import { stepsConfig } from './stepsConfig';
import { NewShipmentFormFields, initialValues } from './types';
import { StepsSidebar } from 'components/new-ui/composed/multistep-form/StepsSidebar';
import Header from './components/header/Header';
import { StyledPageWrapper } from './styles';
import useBreadcrumb from 'hooks/useBreadcrumb';

const CreateShipmentPage = () => {
    const { setBreadcrumbRoutes } = useBreadcrumb();

    const handleInitialize = (formik: FormikContextType<NewShipmentFormFields>) => {
        const generatedId = `shipment-${crypto.randomUUID()}`;
        formik.setFieldValue('shipment.shipmentId', generatedId);
    };

    useEffect(() => {
        setBreadcrumbRoutes([
            {
                breadcrumbName: 'Shipments',
                path: '/shipments',
            },
            {
                breadcrumbName: 'Bulk Irish Import',
                path: '/shipments/new',
            },
        ]);
    }, [setBreadcrumbRoutes]);

    return (
        <MultiStepFormProvider<NewShipmentFormFields>
            initialValues={initialValues}
            steps={stepsConfig}
            onInitialize={handleInitialize}
        >
            <StyledPageWrapper>
                <Header />
                <Row style={{ marginTop: 32 }} gutter={20}>
                    <Col style={{ maxWidth: 210 }} sm={24} md={6}>
                        <StepsSidebar />
                    </Col>
                    <Col sm={24} md={18}>
                        <FormContent />
                    </Col>
                </Row>
            </StyledPageWrapper>
        </MultiStepFormProvider>
    );
};

export default CreateShipmentPage;
